export const ConverDurationToMin = (n: any) => {
    let return_time;
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours == 0) {
        return_time = rminutes + " دقیقه"
    }
    if (rminutes == 0) {
        return_time = rhours + " ساعت "
    }
    if (rminutes != 0 && rhours != 0) {
        return_time = rhours + " ساعت " + rminutes + " دقیقه"
    }
    return return_time;
}